import React from "react";

import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

function Feature4() {
  return (
    <div className="section features-4 bg-default">
      <Container>
        <Row>
          <Col className="text-center mx-auto text-white" md="8">
            <h3 className="display-3 text-info">Advanced Analytics</h3>
            <p className="lead font-weight-bold">
             Our advanced analytics capabilities allow us to trace assets across 
             networks, uncover patterns, and identify illicit activities. Through 
             detailed analysis of transaction histories and network activities, 
             we provide actionable insights to support investigations and regulatory 
             compliance.
            </p>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col className="mr-auto text-left mt-4" lg="4">
            <Card className="bg-info shadow border-0">
              <blockquote className="card-blockquote">
                <h4 className="display-4 font-weight-bolder text-default">Proactive Criminal Activity Mitigation</h4>
                <p className="lead font-weight-bold text-default">
                  Employing proactive strategies, we minimize the risk of criminal 
                  activities. By assessing vulnerabilities, implementing protective 
                  measures, and enhancing overall security, we reduce exposure to 
                  financial crimes and ensure a secure operational environment.
                </p>
              </blockquote>
            </Card>
          </Col>
          <Col className="p-sm-0" lg="7">
            <Row>
              <Col md="6">
                <Card className="card-blog mt-4">
                  <CardBody>
                    <CardTitle tag="h5">
                      <h5 className="text-info font-weight-bold text-center">
                        Incident Response
                      </h5>
                    </CardTitle>
                    <p className="card-description font-weight-bold">
                      In the event of a security breach, our rapid and effective incident 
                      response strategies are designed to minimize damage, recover 
                      compromised assets, and restore security. Our swift mitigation and 
                      robust recovery processes ensure that your operations can quickly 
                      return to normal.
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="card-blog mt-4">
                  <CardBody>
                    <CardTitle tag="h5">
                      <h5 className="text-info font-weight-bold text-center">
                        Threat Intelligence
                      </h5>
                    </CardTitle>
                    <p className="card-description font-weight-bold">
                      Our threat intelligence services deliver detailed insights on threats 
                      to security and financial assets. We identify potential threats, 
                      assess their impact, and provide recommendations for proactive protection 
                      and risk management, ensuring your operations remain secure.
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="mt-lg-4">
              <Col md="6">
                <Card className="card-blog mt-4">
                  <CardBody>
                    <CardTitle tag="h5">
                      <h5 className="text-info font-weight-bold text-center">
                        Private Investigations
                      </h5>
                    </CardTitle>
                    <p className="card-description font-weight-bold">
                      We conduct thorough background checks, asset and person locating, and 
                      surveillance to ensure client privacy and security. Our private investigation 
                      services support AML and CTF requirements, providing comprehensive locating 
                      services and gathering crucial information for investigations.
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="card-blog mt-4">
                  <CardBody>
                    <CardTitle tag="h5">
                      <h5 className="text-info font-weight-bold text-center">
                        Corporate Investigations
                      </h5>
                    </CardTitle>
                    <p className="card-description font-weight-bold">
                      Our corporate investigations team examines financial discrepancies, money 
                      laundering, and potential fraud or theft. We conduct due diligence for mergers 
                      and acquisitions, detect corporate espionage activities, and investigate 
                      employee misconduct to maintain organizational integrity.
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Feature4;
